export class Notifications {
  notificationVO: Notification[];
  constructor(_notificationVO: Notification[]) {
    this.notificationVO = _notificationVO;
  }
}

export interface Notification extends Record<string, any> {
  createdAt: Date;
  id: string;
  notificationType: string;
  readStatus: string;
  title: string;
  updatedAt: Date;
  userId: string;
  metadata: any;
}

//formatted Notifications to be used in html
export interface NotificationList {
  APPROVAL_PENDING?: Notification[];
  ADMIN_ADDED?: Notification[];
  SET_LEVEL_CHANGED?: Notification[];
  SET_LEVEL_INDEPENDENT?: Notification[];
  USER_ADDED?: Notification[];
  USER_ROLE_UPDATED?: Notification[];
}

export const NotificationMap = new Map<string, { isGrouped: boolean; iconClass: string; action: string; url: string }>([
  [
    'APPROVAL_PENDING',
    {
      isGrouped: true,
      iconClass: 'icon-l-profile',
      action: 'MANAGE.REQUEST',
      url: '/facility/manage/manage-request',
    },
  ],
  [
    'ADMIN_ADDED',
    {
      isGrouped: true,
      iconClass: 'icon-l-profile',
      action: 'MANAGE.FACILITIES',
      url: '/facility/manage',
    },
  ],
  [
    'SET_LEVEL_CHANGED',
    {
      isGrouped: false,
      iconClass: 'icon-s-facility',
      action: 'MANAGE.FACILITIES',
      url: '/facility/manage',
    },
  ],
  [
    'SET_LEVEL_INDEPENDENT',
    {
      isGrouped: false,
      iconClass: 'icon-s-facility',
      action: 'MANAGE.FACILITIES',
      url: '/facility/manage',
    },
  ],
  [
    'USER_ADDED',
    {
      isGrouped: false,
      iconClass: 'icon-l-profile',
      action: 'VIEW.STAFF',
      url: '/facility/staff',
    },
  ],
  [
    'USER_ROLE_UPDATED',
    {
      isGrouped: false,
      iconClass: 'icon-l-profile',
      action: 'VIEW.STAFF',
      url: '/facility/staff',
    },
  ],
]);
